
import axios from "axios"

import { createFormData, createAxiosWithToken } from "../utils"

const Apis = {
    sign_in: "/studio_api/admin/sign_in",
    check_token: "/studio_api/admin/check_token",
    get_user_list: "/studio_api/admin/user_list",
    get_admin_list: "/studio_api/admin/admin_list",
    get_collection_site_list: "/studio_api/admin/get_collection_site_list",
    create_collection_site: "/studio_api/admin/create_collection_site",
    update_collection_site: "/studio_api/admin/update_collection_site",
    delete_collection_site: "/studio_api/admin/delete_collection_site",
    get_selling_site_list: "/studio_api/admin/get_selling_site_list",
    create_selling_site: "/studio_api/admin/create_selling_site",
    update_selling_site: "/studio_api/admin/update_selling_site",
    delete_selling_site: "/studio_api/admin/delete_selling_site",
    get_selling_site_filters: "/studio_api/admin/get_selling_site_filters",
    create_selling_site_tag: "/studio_api/admin/create_selling_site_tag",
    update_selling_site_tag: "/studio_api/admin/update_selling_site_tag",
    delete_selling_site_tag: "/studio_api/admin/delete_selling_site_tag",
    create_selling_site_device: "/studio_api/admin/create_selling_site_device",
    update_selling_site_device: "/studio_api/admin/update_selling_site_device",
    delete_selling_site_device: "/studio_api/admin/delete_selling_site_device",
    get_public_component_package_list: "/studio_api/admin/get_public_component_package_list",
    get_public_component_package_info: "/studio_api/admin/get_public_component_package_info",
    create_public_component_package: "/studio_api/admin/create_public_component_package",
    update_public_component_package: "/studio_api/admin/update_public_component_package",
    delete_public_component_package: "/studio_api/admin/delete_public_component_package",
    get_public_component_list: "/studio_api/admin/get_public_component_list",
    create_public_component: "/studio_api/admin/create_public_component",
    update_public_component: "/studio_api/admin/update_public_component",
    delete_public_component: "/studio_api/admin/delete_public_component",
    get_public_component_group_list: "/studio_api/admin/get_public_component_group_list",
    create_public_component_group: "/studio_api/admin/create_public_component_group",
    update_public_component_group: "/studio_api/admin/update_public_component_group",
    delete_public_component_group: "/studio_api/admin/delete_public_component_group",
    get_public_components_in_group: "/studio_api/admin/get_public_components_in_group",
    add_public_component_to_group: "/studio_api/admin/add_public_component_to_group",
    remove_public_component_from_group: "/studio_api/admin/remove_public_component_from_group",
    update_public_component_in_group: "/studio_api/admin/update_public_component_in_group",
    update_public_component_group_relation: "/studio_api/admin/update_public_component_group_relation",
}

export const AdminService = {
    sign_in: (params) => {
        const formData = createFormData(params)
        return axios.post(Apis.sign_in, formData)
    },
    check_token: (params) => {
        const formData = createFormData(params)
        return axios.post(Apis.check_token, formData)
    },
    get_user_list: (params) => {
        return createAxiosWithToken().get(Apis.get_user_list, { params })
    },
    get_admin_list: (params) => {
        return createAxiosWithToken().get(Apis.get_admin_list, { params })
    },
    get_collection_site_list: (params) => {
        return createAxiosWithToken().get(Apis.get_collection_site_list, { params })
    },
    create_collection_site: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_collection_site, formData)
    },
    update_collection_site: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_collection_site, formData)
    },
    delete_collection_site: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_collection_site, formData)
    },
    get_selling_site_list: (params) => {
        return createAxiosWithToken().get(Apis.get_selling_site_list, { params })
    },
    create_selling_site: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_selling_site, formData)
    },
    update_selling_site: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_selling_site, formData)
    },
    delete_selling_site: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_selling_site, formData)
    },
    get_selling_site_filters: (params) => {
        return createAxiosWithToken().get(Apis.get_selling_site_filters, { params })
    },
    create_selling_site_tag: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_selling_site_tag, formData)
    },
    update_selling_site_tag: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_selling_site_tag, formData)
    },
    delete_selling_site_tag: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_selling_site_tag, formData)
    },
    create_selling_site_device: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_selling_site_device, formData)
    },
    update_selling_site_device: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_selling_site_device, formData)
    },
    delete_selling_site_device: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_selling_site_device, formData)
    },
    get_public_component_package_list: (params) => {
        return createAxiosWithToken().get(Apis.get_public_component_package_list, { params })
    },
    get_public_component_package_info: (params) => {
        return createAxiosWithToken().get(Apis.get_public_component_package_info, { params })
    },
    create_public_component_package: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_public_component_package, formData)
    },
    update_public_component_package: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_public_component_package, formData)
    },
    delete_public_component_package: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_public_component_package, formData)
    },
    get_public_component_list: (params) => {
        return createAxiosWithToken().get(Apis.get_public_component_list, { params })
    },
    create_public_component: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_public_component, formData)
    },
    update_public_component: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_public_component, formData)
    },
    delete_public_component: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_public_component, formData)
    },
    get_public_component_group_list: (params) => {
        return createAxiosWithToken().get(Apis.get_public_component_group_list, { params })
    },
    create_public_component_group: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.create_public_component_group, formData)
    },
    update_public_component_group: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_public_component_group, formData)
    },
    delete_public_component_group: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.delete_public_component_group, formData)
    },
    get_public_components_in_group: (params) => {
        return createAxiosWithToken().get(Apis.get_public_components_in_group, { params })
    },
    add_public_component_to_group: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.add_public_component_to_group, formData)
    },
    remove_public_component_from_group: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.remove_public_component_from_group, formData)
    },
    update_public_component_in_group: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_public_component_in_group, formData)
    },
    update_public_component_group_relation: (params) => {
        const formData = createFormData(params)
        return createAxiosWithToken().post(Apis.update_public_component_group_relation, formData)
    }
}
